module.exports = function(gantt) {

	gantt.getTaskType = function (type) {
		return "task";
	};
};